export default "__VITE_ASSET__8UgyNy_l__"